import { Component, OnInit } from '@angular/core';
import { AuthenticationToken, UserRoles } from '../../../authentication/constants/authentication.constants';
import {
  Languages,
  SharedUrls
} from '../../../shared/constants/shared.constants';
import { Router, RouterModule } from '@angular/router';
import { AboutUsComponent } from '../about-us/about-us.component';
import { LayoutService } from '../../state/layout.service';
import { MatDialog } from '@angular/material/dialog';
import { LayoutQuery } from '../../state/layout.query';
import { TranslocoModule, TranslocoService } from '@ngneat/transloco';
import { Language } from '../../../shared/interfaces/language.interface';
import { ToasterService } from '../../../core/toaster/toaster.service';
import { SidenavService } from '../../../shared/services/sidenav.service';
import { AuthenticationService } from '../../../authentication/state/authentication.service';
import { ChangePasswordComponent } from '../../../authentication/components/change-password/change-password.component';
import { RoleConstant } from '../../../user/constants/role.constant';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatMenuModule } from '@angular/material/menu';
import { CommonModule } from '@angular/common';
import { AuthenticationStore } from '../../../authentication/state/authentication.store';
import { AuthenticationQuery } from '../../../authentication/state/authentication.query';

@Component({
  selector: 'app-site-navbar',
  templateUrl: './site-navbar.component.html',
  styleUrls: ['./site-navbar.component.scss'],
  standalone: false,
})
export class SiteNavbarComponent implements OnInit {

  languages = Languages;
  selected = 'en-US';
  language!: Language;
  get selectedLanguage() {
    return this.layoutQuery.layoutState.language;
  }
  constructor(public router: Router,
    private layoutService: LayoutService,
    public layoutQuery: LayoutQuery,
    public dialog: MatDialog,
    private toasterService: ToasterService,
    private translocoService: TranslocoService,
    private sidenavService: SidenavService,
    private authenticationService: AuthenticationService,
    private authStore: AuthenticationStore,
    private authQuery: AuthenticationQuery) { }

  ngOnInit() {
    this.language = this.selectedLanguage;
    // this.selected = this.layoutQuery.layoutState.language.locale || 'en-US';
  }

  userManager() {
    this.router.navigate([SharedUrls.User]);
  }
  logout() {
    localStorage.removeItem(UserRoles.Roles);
    localStorage.removeItem(AuthenticationToken.TokenInfo);
    sessionStorage.clear();
    this.authStore.reset();
    this.router.navigate([SharedUrls.Login]);
  }
  openAboutUsDialog() {
    const dialogRef = this.dialog.open(AboutUsComponent, {
      panelClass: 'dialog-sm',
      direction: this.layoutService.selectedLanguage.dir
    });
  }
  openChangePasswordDialog() {
    const dialogRef = this.dialog.open(ChangePasswordComponent, {
      panelClass: 'dialog-sm',
      direction: this.layoutService.selectedLanguage.dir
    });
  }
  switchLanguage(lang: Language) {
    if (this.translocoService.getActiveLang() !== lang.code) {
      this.translocoService.load(lang.code).subscribe({
        complete: () => {
          this.layoutService.selectLanguage(lang);
          this.toasterService.success(
            this.translocoService.translateObject(
              'layout.messages.changeLanguage'
            )
          );

          this.router.routeReuseStrategy.shouldReuseRoute = () => false;

          this.router.onSameUrlNavigation = 'reload';

          this.router.navigate([SharedUrls.Site]);
        }
      });
    }
  }
  navigateTo(path: string) {
    this.router.navigate([path]);
  }
  close() {
    this.sidenavService.toggle();
  }

  public get isAdmin(): boolean {

    if (this.authenticationService.roles) {
      return this.authenticationService.roles.includes(RoleConstant.sysAdmin);
    }

    return false;
  }

  public get logedInUserName() {
    return this.authenticationService.authenticationQuery.givenName
  }

  Region() {
    this.router.navigate([SharedUrls.Region]);
  }

  public get isRegionReviewer(): boolean {
    if (this.authenticationService.roles) {
      return this.authenticationService.roles.includes(RoleConstant.regionReviewer);
    }
    return false;
  }

}

